import { Link } from 'gatsby';
import React, { useEffect, useState } from 'react';

const PolicyLink = ({ to, children }: { to: string; children: React.ReactNode }): JSX.Element => {
  const [ toHref, setToHref ] = useState(to);
  const windowAvailable = typeof window !== 'undefined';

  useEffect(() => {
    if (windowAvailable) {
      const inAppView = window?.location?.search.includes('hide_chrome=1');
      if (inAppView) {
        if (to.includes('?')) {
          setToHref(_to => `${_to}&hide_chrome=1`)
        } else {
          setToHref(_to => `${_to}?hide_chrome=1`)
        }
      }
    }
  }, [ windowAvailable ])

  if (toHref.startsWith('mailto:')) {
    return (
      <a href={toHref}>
        {children}
      </a>
    )
  }

  return (
    <Link to={toHref}>
      {children}
    </Link>
  )
}

export default PolicyLink;
